/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const CHALLENGE_EAST = 'east'; // V3 (invisible)
export const CHALLENGE_WEST = 'west'; // V2 (checkbox)

export const RECAPTCHA_ACTION_CREATE_ISSUANCE = 'create_issuance';

export const RECAPTCHA_FAILED_MESSAGE =
    'We detected abnormal activity and could not verify this request. Please try again.';

export function buildGateA({ value, isChallengeRequired, action }) {
    return {
        value,
        terminal: isChallengeRequired ? CHALLENGE_WEST : CHALLENGE_EAST,
        origin: window.location.origin,
        description: action,
        success: true,
    };
}

export async function getGateA(recaptcha, action) {
    let value = null;
    try {
        value = await recaptcha.getToken(action);
    } catch {
        value = null;
    }
    return buildGateA({
        value,
        isChallengeRequired: recaptcha.isChallengeRequired,
        action,
    });
}
